import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import * as React from "react";

export const MessageNotificationIcon = (props: SvgIconProps) => {
    const { viewBox = "0 0 24 24", ...rest } = props;

    return (
        <SvgIcon viewBox={viewBox} {...rest}>
            <g>
                <g>
                    <path
                        fill="#3F30A3"
                        d="M20.8,4.5V16h-9.2h-0.5l-0.4,0.4l-1.4,1.4v-0.6V16H8.1H3.2V4.5H20.8 M22,3.3H2v13.9h6.1v3.5l3.5-3.5H22V3.3
			L22,3.3z"
                    />
                </g>
                <g>
                    <rect
                        x="6.3"
                        y="8.1"
                        fill="#3F30A3"
                        width="7.8"
                        height="1.2"
                    />
                </g>
                <g>
                    <rect
                        x="6.3"
                        y="11.3"
                        fill="#3F30A3"
                        width="11.3"
                        height="1.2"
                    />
                </g>
            </g>{" "}
        </SvgIcon>
    );
};
